export default __webpack_public_path__ + "static/thumb-landscape-2056c152a34e277909bf5c4575db88aa.jpg";